import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Decision } from '@games/entities';
import { IDecision } from '@games/interfaces';

@Injectable({
  providedIn: 'root',
})
export class DecisionService {
  periodAdvanced$ = new ReplaySubject<void>(1);

  constructor(private http: HttpClient) {}

  getDecisions(
    courseId: number,
    gameId: number,
    marketId: number,
    entityId: number,
    filters: HttpParams | { [params: string]: string | string[] } = {},
    isSilentLoader = false
  ) {
    return this.http
      .get<any>(
        `${environment.apiUrl}courses/${courseId}/games/${gameId}/groupings/${marketId}/entities/${entityId}/decisions/`,
        {
          params: filters,
          headers: { 'silent-loader': isSilentLoader ? 'true' : 'false' },
        }
      )
      .pipe(
        map(decisions =>
          Object.values(decisions).map((decision: IDecision) => new Decision(decision))
        )
      );
  }

  updateDecision(
    courseId: number,
    gameId: number,
    marketId: number,
    entityId: number,
    modifiedDecision: any
  ) {
    return this.http.post<any>(
      `${environment.apiUrl}courses/${courseId}/games/${gameId}/groupings/${marketId}/entities/${entityId}/decisions/`,
      modifiedDecision
    );
  }
}
